module.exports = __webpack_public_path__ + "media/images/plans/dinner/dinner-og-image-6b21601cbeb959ca367ed3d492601a75.png";